import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

const WithTooltip = ({ children, tooltip }: { children: React.ReactNode, tooltip: string }) => (
    <Tooltip>
        <TooltipTrigger asChild>
            {children}
        </TooltipTrigger>
        <TooltipContent aria-label={tooltip}>
            <p>{tooltip}</p>
        </TooltipContent>
    </Tooltip>
);


export default WithTooltip;